import { render, staticRenderFns } from "./composer-aviso.vue?vue&type=template&id=72736af4&scoped=true&"
import script from "./composer-aviso.vue?vue&type=script&lang=js&"
export * from "./composer-aviso.vue?vue&type=script&lang=js&"
import style0 from "./composer-aviso.vue?vue&type=style&index=0&id=72736af4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72736af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72736af4')) {
      api.createRecord('72736af4', component.options)
    } else {
      api.reload('72736af4', component.options)
    }
    module.hot.accept("./composer-aviso.vue?vue&type=template&id=72736af4&scoped=true&", function () {
      api.rerender('72736af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/composer-aviso/composer-aviso.vue"
export default component.exports